export const CATEGORY_SELECTED = `categories/CATEGORY_SELECTED`

export const CATEGORIES_SUBSCRIBE = `categories/CATEGORIES_SUBSCRIBE`
export const CATEGORIES_UPDATED = `categories/CATEGORIES_UPDATED`

export const CATEGORIES_ADDRESS_UPDATED = `categories/CATEGORIES_ADDRESS_UPDATED`
